import {
    Avatar as BaseAvatar,
    Props as AvatarProps,
} from '@99designs/common/components/Avatar/Avatar';
import { Icon } from '@99designs/common/components/Icon';
import { IconButton } from '@99designs/common/components/IconButton';
import React from 'react';
import { intlShape } from 'react-intl';

export interface Props extends AvatarProps {
    userId: number;
    onRemove?: (userId: number) => void;
    onClick?: () => void;
    avatarCount?: number;
}

const Avatar: React.SFC<Props> = ({ userId, onRemove, onClick, avatarCount, ...avatarProps }) => {
    const user = {
        avatarUrl: `/avatars/users/${userId}/128`,
        profileUrl: `/profiles/${userId}`,
    };

    return (
        <div className="avatar-container">
            <div className="avatar-container__avatar" onClick={onClick}>
                <BaseAvatar variations={['small']} isLinked={false} {...avatarProps} user={user} />
            </div>
            {onRemove && (
                <div className="avatar-container__button">
                    <IconButton
                        variations={['solid']}
                        title={__('Remove designer')}
                        onClick={() => onRemove(userId)}
                    >
                        <Icon type={'x-3'} />
                    </IconButton>
                </div>
            )}
            {avatarCount && avatarCount !== 0 ? (
                <div className="avatar-container__button">
                    <IconButton variations={['solid']} onClick={onClick}>
                        {avatarCount}
                    </IconButton>
                </div>
            ) : (
                undefined
            )}
        </div>
    );
};

Avatar.contextTypes = {
    intl: intlShape.isRequired,
};

export default Avatar;
